<template>
<div>


<div class="grid" v-for="(item,index) in inputdata">


<div class="col-10 md:col-11"> 
<ListColumns :data="data" :columns="this.data.columns"  :line="item" @columnFieldSubmitted="columnFieldSubmitted"></ListColumns>
</div>

<div class="col-2 md:col-1 mt-2">
<Button  v-if="!data.read_only_state" icon="pi pi-trash" @click="deleteLine(item.id)" class=" p-button-danger p-button-outlined  p-button-sm mt-3" :loading="$store.state.ui.submitting"/> 
</div>

</div>






<template v-if="!data.read_only_state">

<template v-if="data.max_item_lenght">
  <div class="grid" v-if="inputdata.length<data.max_item_lenght && !adding_new">
  <div class="col-3 md:col-2"><p class="click_edit_value_title">{{$store.state.languages.lang_phrases.yeni_ekle}}</p></div>
  <div class="col-9 md:col-10">
  <p class="click_add_value">
  <Button type="button"  icon="pi pi-plus"  @click="addNew" class="p-button-primary p-button-outlined p-button-sm mr-2"   />
  </p>
  </div>
  </div>
</template>


<template v-else>
  <div class="grid" v-if="!adding_new">
  <div class="col-3 md:col-2"><p class="click_edit_value_title">{{$store.state.languages.lang_phrases.yeni_ekle}}</p></div>
  <div class="col-9 md:col-10">
  <p class="click_add_value">
  <Button type="button"  icon="pi pi-plus"  @click="addNew" class="p-button-primary p-button-outlined p-button-sm mr-2"   />
  </p>
  </div>
  </div>
</template>

</template>







<template v-if="adding_new">
  
</template>


</div>

</template>

<script>
import ListColumns from "./ListColumns"
export default {

  name: 'InputFieldType',
  props:["data"],

  data () {
    return {
      inputdata:[],
      newline:null,
      intervalobj:null,
      adding_new:false,
      char_length_err:null,
      char_length_err_message:null,
    }
  },
  components:{ListColumns},
  mounted()
  {
    if(this.data.submissions.length>0)
      {
         
        this.arranageListColumns(JSON.parse(this.data.submissions[0].submission_text))
      }
    
    
  },
  computed:{
    propdata()
    {
      
      if(this.data.submissions.length>0)
      {

        let propdata = JSON.parse(this.data.submissions[0].submission_text)
        if(propdata)
        {
          
          //this.arranageListColumns(propdata)
        }
        
        return propdata
      }
    }
  },
  watch:{
    propdata(newval)
    {
      console.log("fired")
      console.log(newval)
      //this.inputdata = newval
      this.arranageListColumns(newval)
    },
  },
  methods: {
    arranageListColumns(submission_text)
    {
        this.inputdata = []
        for(let line of submission_text)
        {
          let input_line = {
          id:line.id,
          columns:line.columns,          
          submissions:[],
        }
        this.inputdata.push(input_line)
      }
      
      console.log(this.inputdata)
      
    },
    columnFieldSubmitted(data)
    {
      let inputdata = this.sanitizeArray(this.inputdata)
      console.log(data)
      let line_ind = inputdata.findIndex((item)=>{return item.id == data.line_id})

      inputdata[line_ind].columns = data.inputdata
      
      for(let input of inputdata)
      {
        delete input.submissions
      }
      console.log(inputdata)
      //return false
      this.fieldChanged(inputdata)


    },
    parseInputdata()
    {
      if(this.data.submissions.length>0)
      {
        let submission_text  = JSON.parse(this.data.submissions[0].submission_text)

        for(let item of submission_text)
        {
          let input = {
            id:item.id,
          }
        }
        
      }
    },
    addNew()
    {
      console.log(this.data)
      let input_line = {
        id:this.generateId(),
        submissions:[],
        columns:[]
      }
      let columns = this.data.columns
      for(let column of columns)
      {
        let item = {
          id:column.id,
          value:null,
        }
        input_line.columns.push(item)
      }
      this.inputdata.push(input_line)

    },
    ValidateEmail(mail) 
    {
     if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
      {
        return (true)
      }
        //alert("You have entered an invalid email address!")
        return (false)
    },
    validateUrl(url)
    {
      try { 
        return Boolean(new URL(url)); 
      }
      catch(e){ 
        return false; 
      }
    },
    validateNumber(value)
    {
      if(isNaN(value))
      {
        return false
      }
      else
      {
        return true
      }
    },
    deleteLine(data)
    {
      let inputdata = this.sanitizeArray(this.inputdata)
      inputdata = inputdata.filter((item)=>{return item.id !==data})
      console.log(data)
      console.log(inputdata)
      //return false
      this.submitInputData(inputdata)
    },
    newAdded(data)
    {
      console.log(this.data)
      console.log(data)
      if(this.data.listinput_type=="email")
      {
        let is_valid = this.ValidateEmail(data.value)
        if(is_valid)
        {
          this.inputdata.push(data.value)
          this.submitInputData()
        }
        else
        {
          this.showMessage("error","Lütfen geçerli bir email adresi ekleyin")
        }
      }

      if(this.data.listinput_type=="number")
      {
        let is_valid = this.validateNumber(data.value)
        if(is_valid)
        {
          this.inputdata.push(data.value)
          this.submitInputData()
        }
        else
        {
          this.showMessage("error","Lütfen geçerli bir sayısal ekleyin")
        }
      }

      if(this.data.listinput_type=="url")
      {
        let is_valid = this.validateUrl(data.value)
        if(is_valid)
        {
          this.inputdata.push(data.value)
          this.submitInputData()
        }
        else
        {
          this.showMessage("error","Lütfen geçerli bir url ekleyin")
        }
      }
       if(this.data.listinput_type=="string" || this.data.listinput_type=="phoneno")
       {
          this.inputdata.push(data.value)
          this.submitInputData()
       }
       if(!this.data.listinput_type)
       {
          this.inputdata.push(data.value)
          this.submitInputData()
       }
      
    },
    fieldChanged(inputdata)
    {
      this.char_length_err = false
      this.char_length_err_message = null
      this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
      clearInterval(this.intervalobj);
      this.intervalobj = setInterval(()=>{
        this.submitInputData(inputdata)
      },1000)
    },
    submitInputData(inputdata)
    {
      clearInterval(this.intervalobj);

      
      let jsondata = JSON.stringify(inputdata)
      let formdata = new FormData()
      formdata.append("text",jsondata)
      formdata.append("type","listinput")
      formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.uuid)
      console.log(this.inputdata);
      this.submitInputFieldSubmission(formdata,this.data.id)
    },
  }
};
</script>

<style lang="css" scoped>
</style>